import tippy from 'tippy.js'
import 'tippy.js/dist/tippy.css'

$(function () {
    document.querySelectorAll('.tooltip').forEach(tooltip => {
        tippy(tooltip, {
            content(reference) {
                return reference.getAttribute('data-tooltip')
            }
        })
    })
})